// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1OZcX","label":"Section_label__BF_Kl","contentWrap":"Section_contentWrap__3TA6H","footer":"Section_footer__1oevc","footerInner":"Section_footerInner__3Vjle"};